/* This function determines whether to hide the HoverIcon in the IconBar for a given scenario where
   we would need to allocate space for the icon but not show it. We want to allocate space
   for the icon to prevent shifting either between hover/non-hover state when the iconbar is rendered
   in the received column.

    // This function is used the following  style properties:

    ListViewItemCommonStyles.scss
        .mailListItemContainer:hover {
            ...
            --iconVisibilityWhenDefaultHidden: visible;
        }

    MailListItemPart.scss
        .showItemPartHoverActionsOnHover:hover {
            ...
            --iconVisibilityWhenDefaultHidden: visible;
        }

   IconBar.scss
        .iconHide {
            visibility: var(--iconVisibilityWhenDefaultHidden, hidden);
        }
  */

export default function shouldHideHoverIconWhenIconBarRight(hoverIconKey: string, isFlagged: boolean, isComplete: boolean, isPinned: boolean): boolean {
    switch (hoverIconKey) {
        case "pinIcon":
            // if flagged or complete and not pinned, hide pin icon to prevent shifting
            return (isFlagged || isComplete) && !isPinned;
        default:
            /* When item has flagged and/or pinned status, allocate space for icons that
                   appear to the right of the flag icon, but set visibility to hidden. We may
                   add support for these in the future.*/
            return ((hoverIconKey === "deleteIcon" || hoverIconKey === "archiveIcon") &&
                (isFlagged || isComplete || isPinned));
    }
}
